import { loadLibrary } from "../../js/Util";
import { LIB_URL } from '../../js/App';

if ($('.js-simple-slider').length) {
    const $slider = $('.js-simple-slider');

    $slider.each((i, sliderDom) => {
        if ($(sliderDom).find('.swiper-slide').length > 1) {
            $(sliderDom).removeClass('_no-slider');
            loadLibrary(LIB_URL.SWIPER, () => {
                const slider = new Swiper(sliderDom, {
                    slidesPerView: 1,
                    navigation: {
                        nextEl: '.js-simple-slider-next',
                        prevEl: '.js-simple-slider-prev',
                    },
                    pagination: {
                        el: '.js-simple-slider-pagination',
                        type: 'bullets',
                    },
                });
            });
        } else {
            $(sliderDom).addClass('_no-slider');
        }
    });
}